<template>
  <div class="plateNumber">
    <div class="wrap">
      <div class="flex text-16 px-16 font-500 text-primary justify-between">
        <div @click="cancel()">取消</div>
        <div @click="submitFn()">确认</div>
      </div>
      <div class="num-box mt-16">
        <div :class="{ active: activeKeyWordIndex == 0 }" @click="clickKeyWordWrap(0)" class="num-item">
          <span>{{ formData.num0 }}</span>
        </div>
        <div :class="{ active: activeKeyWordIndex == 1 }" @click="clickKeyWordWrap(1)" class="num-item">
          <span>{{ formData.num1 }}</span>
        </div>
        <em class="spot"></em>
        <div :class="{ active: activeKeyWordIndex == 2 }" @click="clickKeyWordWrap(2)" class="num-item">
          <span>{{ formData.num2 }}</span>
        </div>
        <div :class="{ active: activeKeyWordIndex == 3 }" @click="clickKeyWordWrap(3)" class="num-item">
          <span>{{ formData.num3 }}</span>
        </div>
        <div :class="{ active: activeKeyWordIndex == 4 }" @click="clickKeyWordWrap(4)" class="num-item">
          <span>{{ formData.num4 }}</span>
        </div>
        <div :class="{ active: activeKeyWordIndex == 5 }" @click="clickKeyWordWrap(5)" class="num-item">
          <span>{{ formData.num5 }}</span>
        </div>
        <div :class="{ active: activeKeyWordIndex == 6 }" @click="clickKeyWordWrap(6)" class="num-item">
          <span>{{ formData.num6 }}</span>
        </div>
        <div
          :class="{ active: activeKeyWordIndex == 7 }"
          class="relative num7 num-item"
          @click="clickKeyWordWrap(7)"
          v-if="maxLength === 8"
        >
          <span>{{ formData.num7 }}</span>
          <span class="append">新能源</span>
        </div>
      </div>
      <div class="keyboard-wrap" v-if="activeKeyWordIndex === 0">
        <div class="province-wrap relative">
          <Button v-for="(item, index) in provinceWords" :key="index" @click="clickKeyBoard(item)" class="btn-item">
            {{ item }}
          </Button>
          <div class="btn-item" style="height: 0; border: 0"></div>
          <div class="btn-item" style="height: 0; border: 0"></div>
          <div class="btn-item" style="height: 0; border: 0"></div>
          <Button class="btn-item close-btn" @click="deleteCurrentKey">
            <Icon name="back" svgClass="font-24" />
          </Button>
        </div>
      </div>
      <div class="keyboard-wrap" v-else>
        <div class="pt-24 pb-32">
          <div class="number-wrap flex justify-between mb-4" v-if="activeKeyWordIndex !== 1">
            <Button v-for="(item, index) in numberWords" :key="index" @click="clickKeyBoard(item)" class="btn-item">
              {{ item }}
            </Button>
          </div>
          <div class="capital-wrap flex flex-wrap justify-between">
            <Button v-for="(item, index) in capitalWords" :key="index" @click="clickKeyBoard(item)" class="btn-item">
              {{ item }}
            </Button>
            <template v-if="trailer && activeKeyWordIndex === 6">
              <Button v-for="(item, index) in trailerWords" :key="index" @click="clickKeyBoard(item)" class="btn-item">
                {{ item }}
              </Button>
            </template>
            <template v-else>
              <div class="btn-item" style="height: 0; border: 0"></div>
              <div class="btn-item" style="height: 0; border: 0"></div>
            </template>

            <div class="btn-item" style="height: 0; border: 0"></div>

            <Button class="btn-item close-btn" @click="deleteCurrentKey">
              <Icon name="back" svgClass="font-24"
            /></Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, Toast } from 'vant';
import Icon from '@/components/Icon/index';
export default {
  name: 'carnumber-board',
  props: {
    defaultValue: {
      type: String,
      default: ''
    },
    trailer: {
      type: Boolean,
      default: false
    }
  },
  emits: ['hide', 'getPlateLicense'],
  data() {
    return {
      formData: {
        num0: '',
        num1: '',
        num2: '',
        num3: '',
        num4: '',
        num5: '',
        num6: '',
        num7: ''
      },
      numberWords: [1, 2, 3, 4, 5, 6, 7, 8, 9, 0],
      capitalWords: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'J',
        'K',
        'L',
        'M',
        'N',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
      ],
      provinceWords: [
        '京',
        '沪',
        '津',
        '渝',
        '鲁',
        '冀',
        '晋',
        '蒙',
        '辽',
        '吉',
        '黑',
        '苏',
        '浙',
        '皖',
        '闽',
        '赣',
        '豫',
        '湘',
        '鄂',
        '粤',
        '桂',
        '琼',
        '川',
        '贵',
        '云',
        '藏',
        '陕',
        '甘',
        '青',
        '宁',
        '新'
      ],
      trailerWords: ['挂', '超'],
      activeKeyWordIndex: 0, // 当前车牌号

      confirmTitle: '',
      submitConfirm: false,
      submitConfirmFalse: false,
      submitConfirmText: '',

      maxLength: 8
    };
  },
  components: {
    Button
  },
  mounted() {
    this.open();
  },
  watch: {
    defaultValue(val) {
      const value = val || '';
      this.maxLength = this.trailer ? 7 : 8;
      let n = value;
      if (n && n.length > this.maxLength) {
        n = '';
      }
      n.split('').forEach((item, index) => {
        this.formData[`num${index}`] = item;
      });
    }
  },
  methods: {
    open() {
      const value = this.defaultValue || '';
      this.maxLength = this.trailer ? 7 : 8;
      let n = value;
      if (n && n.length > this.maxLength) {
        n = '';
      }
      n.split('').forEach((item, index) => {
        this.formData[`num${index}`] = item;
      });
    },

    clearInput() {
      this.formData = {
        commonCard: '1',
        num0: '',
        num1: '',
        num2: '',
        num3: '',
        num4: '',
        num5: '',
        num6: '',
        num7: ''
      };
      this.checked = false;
    },

    deleteCurrentKey() {
      const val = this.formData[`num${this.activeKeyWordIndex}`];
      this.formData[`num${this.activeKeyWordIndex}`] = '';
      if (this.activeKeyWordIndex > 0 && !val) {
        this.activeKeyWordIndex--;
      }
    },

    clickKeyBoard(item) {
      this.formData['num' + this.activeKeyWordIndex] = item;
      if (this.activeKeyWordIndex < this.maxLength - 1) {
        this.activeKeyWordIndex++;
      }
    },

    cancel() {
      this.$emit('hide');
    },
    submitFn() {
      let plateLicense;
      plateLicense = this.plate_license_2;
      plateLicense = this.palindrome(plateLicense);
      if (plateLicense.length < 7) {
        // alert('请输入正确的车牌号')
        Toast('请输入正确的车牌号');
        return;
      }

      this.$emit('getPlateLicense', plateLicense);
      this.$emit('hide');
      // alert(plateLicense)
    },
    palindrome(str) {
      var arr = str.split('');
      arr = arr.filter(function(val) {
        return (
          val !== ' ' &&
          val !== ',' &&
          val !== '.' &&
          val !== '?' &&
          val !== ':' &&
          val !== ';' &&
          val !== '`' &&
          val !== "'" &&
          val !== '_' &&
          val !== '/' &&
          val !== '-' &&
          val !== '\\' &&
          val !== '' &&
          val !== '(' &&
          val !== ')'
        );
      });
      return arr.join('');
    },
    clickKeyWordWrap(activeKeyWordIndex) {
      this.activeKeyWordIndex = activeKeyWordIndex;
    },
    checkIsHasSpecialStr(str) {
      var flag = false;
      var arr = str.split('');
      arr.forEach(val => {
        if (
          val === '!' ||
          val === '}' ||
          val === '{' ||
          val === ']' ||
          val === '[' ||
          val === '&' ||
          val === '$' ||
          val === '@' ||
          val === ' ' ||
          val === ',' ||
          val === '.' ||
          val === '?' ||
          val === ':' ||
          val === ';' ||
          val === '`' ||
          val === "'" ||
          val === '_' ||
          val === '/' ||
          val === '-' ||
          val === '\\' ||
          val === '' ||
          val === '(' ||
          val === ')'
        ) {
          flag = true;
        }
      });
      return flag;
    },
    checkIsHasChineseStr(str) {
      var Reg = /.*[\u4e00-\u9fa5]+.*/;
      if (Reg.test(str)) {
        return true;
      }
      return false;
    }
  },
  computed: {
    plate_license_1() {
      return (
        this.formData.num0 +
        this.formData.num1 +
        this.formData.num2 +
        this.formData.num3 +
        this.formData.num4 +
        this.formData.num5 +
        this.formData.num6
      );
    },
    plate_license_2() {
      return (
        this.formData.num0 +
        this.formData.num1 +
        this.formData.num2 +
        this.formData.num3 +
        this.formData.num4 +
        this.formData.num5 +
        this.formData.num6 +
        this.formData.num7
      );
    }
  }
};
</script>
<style lang="less" scoped>
.plateNumber {
  height: auto;
  padding-top: 32px;
}
.box-check {
  font-size: 28px;
  height: 76px;
}
:deep(.icon-class) {
  font-size: 32px;
  vertical-align: 0 !important;
}
.spot {
  &::after {
    content: '·';
  }
}
@-webkit-keyframes active {
  0% {
    opacity: 0.8;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 0.8;
  }
}

.wrap {
  background-color: #fff;
  border-radius: 100px;

  .num-box {
    display: flex;
    justify-content: space-between;
    padding: 0.24rem 0.16rem;
    align-items: center;

    .num-item {
      width: 0.38rem;
      height: 0.48rem;
      border: 1px solid rgba(188, 188, 188, 0.5);
      border-radius: 5px;

      &.active {
        border: 1px solid #4a90e2;
        &:after {
          border-bottom: 50px solid #4a90e2;
        }
      }
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        color: #000;
      }
    }
    .num7 {
      border: 1px solid #08a680;
      .append {
        font-size: 10px;
        position: absolute;
        top: 0;
        left: 0;
        color: #08a680;
        display: block;
        text-align: center;
        height: 0.16rem;
        background: #08a68033;
        transform: translateY(-100%);
        border-radius: 4px 4px 0 0;
      }
    }
  }
}

.keyboard-wrap {
  background-color: #ebebeb;
}
.province-wrap {
  display: flex;
  flex-wrap: wrap;
  padding: 24px 0 32px 0.04rem;
  .btn-item {
    padding: 0;
    width: 0.44rem;
    height: 0.44rem;
    font-size: 16px;
    font-weight: 400;
    background-color: white;
    border: 1px solid #c6c6c6;
    box-sizing: border-box;
    color: #333;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0 8px 0.08rem;
  }
  .btn-item.close-btn {
    background: #b1b9c6;
    box-shadow: 0 1px 0 0 #00000080;
  }
}
.number-wrap {
  padding: 0.06rem 0.06rem;
  .btn-item {
    width: 0.34rem;
    height: 0.44rem;
    font-size: 16px;
    font-weight: 400;
    background-color: white;
    border: 1px solid #c6c6c6;
    box-sizing: border-box;
    color: #333;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.capital-wrap {
  padding: 2px 0.08rem 2px 0.08rem;
  .btn-item {
    padding: 0;
    width: 0.44rem;
    height: 0.44rem;
    font-size: 16px;
    font-weight: 400;
    background-color: white;
    border: 1px solid #c6c6c6;
    box-sizing: border-box;
    color: #333;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0rem 8px 0.04rem;
  }
  .btn-item.close-btn {
    background: #b1b9c6;
    box-shadow: 0 1px 0 0 #00000080;
  }
}
</style>
